var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useSession } from '@/contexts/LitSessionProvider';
import { Keypair } from '@solana/web3.js';
import { ethers } from 'ethers';
import { useEffect, useRef } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import bs58 from 'bs58';
var crypto = require('crypto');
export default function useGetWrappedWallet() {
    var _this = this;
    var _a;
    var _b = useSession(), getEVMEthersv5Wallet = _b.getEVMEthersv5Wallet, getSolanaKeypair = _b.getSolanaKeypair, clients = _b.clients, litSession = _b.litSession, PKP = _b.PKP, decryptedWallets = _b.decryptedWallets, clearLitSession = _b.clearLitSession;
    var evmRetryCount = useRef(0);
    var solanaRetryCount = useRef(0);
    var encryptionSig = (_a = (localStorage.getItem('genius-lit-cached-min-sig') ||
        localStorage.getItem('genius-decryption-signature'))) === null || _a === void 0 ? void 0 : _a.slice(3, 35);
    var _c = useLocalStorage('cipher1', null), evmWalletLC = _c[0], setEvmWalletLC = _c[1];
    var _d = useLocalStorage('cipher2', null), solanaWalletLC = _d[0], setSolanaWalletLC = _d[1];
    var _e = useQuery({
        queryKey: ['evmWallet'],
        queryFn: function () { return __awaiter(_this, void 0, Promise, function () {
            var startTime, wallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evmRetryCount.current += 1;
                        startTime = new Date().getTime();
                        return [4 /*yield*/, getEVMEthersv5Wallet()];
                    case 1:
                        wallet = _a.sent();
                        if (!wallet && PKP && litSession && (clients === null || clients === void 0 ? void 0 : clients.litNodeClient) && evmRetryCount.current > 3) {
                            throw new Error('unable to decrypt evm wallet');
                        }
                        return [2 /*return*/, wallet];
                }
            });
        }); },
        gcTime: 1000 * 2,
        retryDelay: 300,
        staleTime: 1000 * 60 * 60 * 24 * 5,
        enabled: !!(clients === null || clients === void 0 ? void 0 : clients.litNodeClient) && !!PKP && !!litSession && !!(decryptedWallets === null || decryptedWallets === void 0 ? void 0 : decryptedWallets.length),
    }), evmWallet = _e.data, evmWalletLoading = _e.isLoading;
    var _f = useQuery({
        queryKey: ['solanaWallet'],
        queryFn: function () { return __awaiter(_this, void 0, Promise, function () {
            var startTime, wallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        solanaRetryCount.current += 1;
                        startTime = new Date().getTime();
                        return [4 /*yield*/, getSolanaKeypair()];
                    case 1:
                        wallet = _a.sent();
                        if (!wallet && PKP && litSession && (clients === null || clients === void 0 ? void 0 : clients.litNodeClient) && solanaRetryCount.current > 3) {
                            throw new Error('unable to decrypt solana wallet');
                        }
                        return [2 /*return*/, wallet];
                }
            });
        }); },
        gcTime: 1000 * 2,
        staleTime: 1000 * 60 * 60 * 24 * 5,
        retry: 3,
        retryDelay: 300,
        enabled: !!(clients === null || clients === void 0 ? void 0 : clients.litNodeClient) && !!PKP && !!litSession && !!(decryptedWallets === null || decryptedWallets === void 0 ? void 0 : decryptedWallets.length),
    }), solanaWallet = _f.data, solanaWalletLoading = _f.isLoading;
    var maxWaitTime = 1000 * 12;
    var evmWalletWaitTime = useRef(0);
    var solanaWalletWaitTime = useRef(0);
    var evmWalletRef = useRef(null);
    var solanaWalletRef = useRef(null);
    useEffect(function () {
        if (evmWallet) {
            evmWalletRef.current = evmWallet;
            var privateKey = evmWallet.privateKey;
            var encryptedEVMKey = encrypt(privateKey, encryptionSig);
            setEvmWalletLC(encryptedEVMKey);
        }
        if (solanaWallet) {
            solanaWalletRef.current = solanaWallet;
            var privateKey = bs58.encode(solanaWallet.secretKey);
            var encyptedSVMKey = encrypt(privateKey, encryptionSig);
            setSolanaWalletLC(encyptedSVMKey);
        }
    }, [evmWallet, solanaWallet]);
    var getEVMWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var decryptedPrivateKey, wallet;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!evmWalletRef.current) return [3 /*break*/, 1];
                    return [2 /*return*/, evmWalletRef.current];
                case 1:
                    if (!evmWalletLC) return [3 /*break*/, 2];
                    decryptedPrivateKey = decrypt(evmWalletLC, encryptionSig);
                    wallet = new ethers.Wallet(decryptedPrivateKey);
                    return [2 /*return*/, wallet];
                case 2: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 200); })];
                case 3:
                    _a.sent();
                    evmWalletWaitTime.current += 200;
                    console.log('evmWalletWaitTime', evmWalletWaitTime.current, evmWalletRef.current);
                    if (evmWalletWaitTime.current > maxWaitTime) {
                        toast.error('We had an error setting up your account. Please try logging out and back in.');
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, getEVMWallet()];
                case 4: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var getSolanaWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var decryptedPrivateKey, keypair;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!solanaWalletRef.current) return [3 /*break*/, 1];
                    return [2 /*return*/, solanaWalletRef.current];
                case 1:
                    if (!solanaWalletLC) return [3 /*break*/, 2];
                    decryptedPrivateKey = decrypt(evmWalletLC, encryptionSig);
                    keypair = Keypair.fromSecretKey(bs58.decode(decryptedPrivateKey));
                    return [2 /*return*/, keypair];
                case 2: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 200); })];
                case 3:
                    _a.sent();
                    solanaWalletWaitTime.current += 200;
                    if (solanaWalletWaitTime.current > maxWaitTime) {
                        toast.error('We had an error setting up your account. Please try logging out and back in.');
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, getSolanaWallet()];
                case 4: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    return { getEVMWallet: getEVMWallet, getSolanaWallet: getSolanaWallet };
}
var algorithm = 'aes-256-ctr';
var encrypt = function (text, secretKey) {
    var iv = crypto.randomBytes(16);
    var cipher = crypto.createCipheriv(algorithm, secretKey, iv);
    var encrypted = Buffer.concat([cipher.update(text), cipher.final()]);
    return {
        iv: iv.toString('hex'),
        content: encrypted.toString('hex'),
    };
};
var decrypt = function (hash, secretKey) {
    var decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(hash.iv, 'hex'));
    var decrpyted = Buffer.concat([
        decipher.update(Buffer.from(hash.content, 'hex')),
        decipher.final(),
    ]);
    return decrpyted.toString();
};
